module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAUZJREFUOI2lkTFLQlEYhp/vpBRtbUGBBg0NBdHSEDgYFDQ0tLW2Sqb9hH6AilZLY2tDU6CRl3QLIlpbmyQiIyPieu/XoFwz79ULvdM58D3PeT8O/DPincqlOUw7NjDhmg82D+69+3VuCeQSo7usH95FOnBhFXGqgkwOCIyi1eIyyfQj5dIC6twCDQxPAJHu0BnIs6qkENfpE6i2SGY6sDg1oMGESZBIN3sCZBH0iI3Mje+iVm4e26kBr134xSuIqggIKm4g3DZ1P7gjGBYrH6dt6ihND7ZOpqkUtkcLrHwcW/phANveQ7gYLrCKs9hSB1oDtUWiAtFgwVVxHNv1h30StMJDGBi8b/yVrfQ3sDMK7DUQUUW/EKbCIRpTaP5tcI6yT6WwAqqBrMgYsAZ63GsAEHlPIZoF/Rz+uDqonvI2kw3XNkR+AGOpfrJrqs88AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classEdit-icon.png
// module id = 1051
// module chunks = 1